/**
 * External flows (e.g. invitation email) should send the user to this path.
 */
export const EXTERNAL_LOGIN_PATH = '/login'

/**
 * If we're on the EXTERNAL_LOGIN_PATH, return the (untrusted!) invitation and
 * organization params. Otherwise, return undefined for both params.
 */
const getAuth0LoginURLParams = () => {
  if (
    ![EXTERNAL_LOGIN_PATH, EXTERNAL_LOGIN_PATH + '/'].includes(window.location.pathname)
  ) {
    return { invitation: undefined, organization: undefined }
  }
  const params = new URLSearchParams(window.location.search)
  return {
    invitation: params.get('invitation') ?? undefined,
    organization: params.get('organization') ?? undefined,
  }
}

export default getAuth0LoginURLParams
